import { getParam } from '../common/util'

export const channelMap = {
  'baidu-ocpc': ['aidsqys:11000-11009', 'bdys'],
  'weixin-ocpa': ['tx-wxmp'],
  'gdt-ocpa': ['tx-gdt'],
  'jrtt-2hu': ['jrtt-2hu'],
  'jrtt-4hu': ['jrtt-4hu'],
  'jrtt-7hu': ['jrtt-7hu'],
  'jrtt-20hu': ['jrtt-20hu'],
  'jrtt-bjbc-1hu': ['jrtt-bjbc-1hu'],
  'jrtt-bjbc-2hu': ['jrtt-bjbc-2hu'],
  'jrtt-gwl-1hu': ['jrtt-gwl-1hu'],
  'jrtt-gwl-2hu': ['jrtt-gwl-2hu'],
  'jrtt-qxhd-1hu': ['jrtt-qxhd-1hu'],
  'jrtt-qxhd-2hu': ['jrtt-qxhd-2hu'],
  'jrtt-szsd-1hu': ['jrtt-szsd-1hu'],
  'jrtt-yksq-1hu': ['jrtt-yksq-1hu'],
  'mm-tiant-1hu': ['mm-tiant-1hu'],
  'mm-tiant-5hu': ['mm-tiant-5hu'],
  'gdt-szsd-1hu': ['gdt-szsd-1hu'],
  'gdt-szsd-2hu': ['gdt-szsd-2hu'],
  'gdt-yksq-1hu': ['gdt-yksq-1hu'],
  'yima01': ['yima01']
}

export const track = {
  'baidu-ocpc': {
    init() {
      window._agl = window._agl || []
      window._agl.push(
        ['production', '_f7L2XwGXjyszb4d1e2oxPybgD']
      )
      asyncImport('https://fxgate.baidu.com/angelia/fcagl.js?production=_f7L2XwGXjyszb4d1e2oxPybgD')
    },
    action() {
      window._agl && window._agl.push(['track', ['success', { t: 3 }]])
    }
  },
  'weixin-ocpa': {
    init() {
      require.ensure([], require => {
        require('../xhpopulrz/common/wxTrack.js')
      })
    },
    action() {
      window.wxTrack && window.wxTrack.addUserActions({
        appChannel: getParam('appChannel')
      })
    }
  },
  'gdt-ocpa': {
    init() {
      require.ensure([], require => {
        require('../xhpopulrz/common/txTrack.js')
      })
    },
    action() {
      window.txTrack && window.txTrack.addUserActions({
        appChannel: getParam('appChannel')
      })
    }
  },
  'jrtt-2hu': {
    init() {
      addJrttJs(51693858838)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1540549891100/index.html':
          window.meteor.track('form', { convert_id: 1626620940564491 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1534409033451/index.html':
          window.meteor.track('form', { convert_id: 1626620982692872 })
          break
      }
    }
  },
  'jrtt-4hu': {
    init() {
      addJrttJs(58540755392)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1540549891100/index.html':
          window.meteor.track('form', { convert_id: 1626621838629902 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1534409033451/index.html':
          window.meteor.track('form', { convert_id: 1626621866876932 })
          break
      }
    }
  },
  'jrtt-7hu': {
    init() {
      addJrttJs(65857201519)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1540549891100/index.html':
          window.meteor.track('form', { convert_id: 1626620328714247 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1534409033451/index.html':
          window.meteor.track('form', { convert_id: 1626620386851843 })
          break
      }
    }
  },
  'jrtt-20hu': {
    init() {
      addJrttJs(76911481441)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1540549891100/index.html':
          window.meteor.track('form', { convert_id: 1626621932314638 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1534409033451/index.html':
          window.meteor.track('form', { convert_id: 1626621957764104 })
          break
      }
    }
  },
  'jrtt-bjbc-1hu': {
    init() {
      addJrttJs(1629852359239687)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631482328507400 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631482365046796 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631482442966020 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631482484571144 })
          break
      }
    }
  },
  'jrtt-bjbc-2hu': {
    init() {
      addJrttJs(1629852844873739)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631482557073422 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631482654577667 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631482691323917 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631482744019980 })
          break
      }
    }
  },
  'jrtt-gwl-1hu': {
    init() {
      addJrttJs(1631137633349639)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631481941351437 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631481984886787 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631482030583821 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631482069851144 })
          break
      }
    }
  },
  'jrtt-gwl-2hu': {
    init() {
      addJrttJs(1631206756835336)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631482135730183 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631482179483651 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631482208854027 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631482240413704 })
          break
      }
    }
  },
  'jrtt-qxhd-1hu': {
    init() {
      addJrttJs(1630314982405131)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631483091779595 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631483132720132 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631483175480324 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631483208629260 })
          break
      }
    }
  },
  'jrtt-qxhd-2hu': {
    init() {
      addJrttJs(1630317101737997)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631483251696651 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631483285694477 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631483320860686 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631483352726535 })
          break
      }
    }
  },
  'jrtt-szsd-1hu': {
    init() {
      addJrttJs(1631138052549636)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631481041436683 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631481553881100 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631481694174216 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631481746080780 })
          break
      }
    }
  },
  'jrtt-yksq-1hu': {
    init() {
      addJrttJs(1629878569781259)
    },
    action() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555906441071/index.html':
          window.meteor.track('form', { convert_id: 1631482823530504 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906764432/index.html':
          window.meteor.track('form', { convert_id: 1631482859512843 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555906971733/index.html':
          window.meteor.track('form', { convert_id: 1631482897714187 })
          break
        case '/groundpage/market/pagetemplate/templatefile/1555907234961/index.html':
          window.meteor.track('form', { convert_id: 1631482939119629 })
          break
      }
    }
  },
  'mm-tiant-1hu': {
    init() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555394072103/index.html':
          addMoMoJs(190422103037394)
          break
        case '/groundpage/market/pagetemplate/templatefile/1555385794463/index.html':
          addMoMoJs(190422103137395)
          break
        case '/groundpage/market/pagetemplate/templatefile/1555396041264/index.html':
          addMoMoJs(190422103237396)
          break
        case '/groundpage/market/pagetemplate/templatefile/1555397158853/index.html':
          addMoMoJs(190422103337397)
          break
      }
    },
    action() {
      window.sendLosMeth && window.sendLosMeth('submit');
    }
  },
  'mm-tiant-5hu': {
    init() {
      switch (location.pathname) {
        case '/groundpage/market/pagetemplate/templatefile/1555394072103/index.html':
          addMoMoJs(190422101837389)
          break
        case '/groundpage/market/pagetemplate/templatefile/1555385794463/index.html':
          addMoMoJs(190422102137390)
          break
        case '/groundpage/market/pagetemplate/templatefile/1555396041264/index.html':
          addMoMoJs(190422102237391)
          break
        case '/groundpage/market/pagetemplate/templatefile/1555397158853/index.html':
          addMoMoJs(190422102437393)
          break
      }
    },
    action() {
      window.sendLosMeth && window.sendLosMeth('submit');
    }
  },
  'gdt-szsd-1hu': {
    init() {
      addGdtJs(1108943254);
    },
    action() {
      window.gdt('track', 'REGISTER', {});
    }
  },
  'gdt-szsd-2hu': {
    init() {
      addGdtJs(1108943322);
    },
    action() {
      window.gdt('track', 'REGISTER', {});
    }
  },
  'gdt-yksq-1hu': {
    init() {
      addGdtJs(1108007129);
    },
    action() {
      window.gdt('track', 'REGISTER', {});
    }
  },
  'yima01': {
    init() {
      asyncImport('https://static.adhudong.com/display/public/conversion/conversion.min.js');
    },
    action() {
      /* global emar */
      emar.saveEffect({
        type: 4,
        uid: 235
      });
    }
  }
}
function addGdtJs(l) {
  !(function(g, d, t, e, v, n, s) {
    if (g.gdt) return;
    v = g.gdt = function() {
      v.tk ? v.tk.apply(v, arguments) : v.queue.push(arguments)
    };
    v.sv = '1.0';
    v.bt = 0;
    v.queue = [];
    n = d.createElement(t);
    n.async = !0;
    n.src = e;
    s = d.getElementsByTagName(t)[0];
    s.parentNode.insertBefore(n, s);
  }(window, document, 'script', '//qzonestyle.gtimg.cn/qzone/biz/gdt/dmp/user-action/gdtevent.min.js'));
  window.gdt('init', l + '');
  window.gdt('track', 'PAGE_VIEW');
}
function addJrttJs(l) {
  let meteor = window.meteor = window.meteor || []
  meteor.methods = ['track', 'off', 'on']
  meteor.factory = function(method) {
    return function() {
      let args = Array.prototype.slice.call(arguments);
      args.unshift(method);
      meteor.push(args);
      return meteor
    }
  }
  for (let i = 0; i < meteor.methods.length; i++) {
    let key = meteor.methods[i]
    meteor[key] = meteor.factory(key)
  }
  asyncImport('https://analytics.snssdk.com/meteor.js/v1/' + l + '/sdk')
  if (meteor.invoked) { return }
  meteor.invoked = true
  meteor.track('pageview')
}

function addMoMoJs(l) {
  window.logsMomoUserId = l + '';
  asyncImport('https://s.momocdn.com/w/u/others/custom/conver/mycustom/converjsonp.js?r=' + Math.ceil(Math.random() * 10));
}

export function asyncImport(src) {
  const script = document.createElement('script')
  script.async = true
  script.src = src
  let s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(script, s)
}

export function getTrackerByType(type) {
  let trackName = null

  Object.keys(channelMap).some(key => {
    let channelList = channelMap[key]

    for (let i = 0; i < channelList.length; i++) {
      let channelItem = channelList[i]

      if (type.indexOf(channelItem) !== -1) {
        trackName = key
        return true
      }
    }
  })

  return trackName
}

export function getTracker(channel) {
  let trackName = null

  Object.keys(channelMap).some(key => {
    let channelList = channelMap[key]

    for (let i = 0; i < channelList.length; i++) {
      let channelItem = channelList[i]

      if (channel.indexOf('-') === -1) {
        const keyArray = channelItem.split(':')

        if (keyArray.length > 1) {
          const channelArray = channel.match(/([a-z]+)(\d+)/)
          const type = channelArray && channelArray[1]
          const number = channelArray && channelArray[2]
          let channelType = keyArray[0]
          let channelRange = keyArray[1].split('-').map(i => parseInt(i))

          if (type === channelType && number >= channelRange[0] && number <= channelRange[1]) {
            trackName = key
            return true
          }
        }

      } else {
        if (channel.indexOf(channelItem) !== -1) {
          trackName = key
          return true
        }
      }
    }
  })


  return trackName
}


export function iosVerion(num) {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf('like mac os x') > 0) {
    let reg = /os [\d._]*/gi
    let verinfo = ua.match(reg)
    let version = String(verinfo)
      .replace(/[^0-9|_.]/gi, '')
      .replace(/_/gi, '.')
    console.log('version', version)
    let arr = version.split('.')
    console.log('arr', arr)

    let versionNum = Number(arr[0])
    if (versionNum >= num) {
      // 对15以后的版本处理,
      console.log('15')
      return true
    }
    // 15以前的版本
    console.log('15以下')
    return false
  }
}

export function getTimer() {
  const time = new Date();
  const year = time.getFullYear();
  const month = time.getMonth() + 1;
  const day = time.getDate();
  let hour = time.getHours();
  hour = hour < 10 ? '0' + hour : hour;
  let min = time.getMinutes();
  min = min < 10 ? '0' + min : min;
  let second = time.getSeconds();
  second = second < 10 ? '0' + second : second;
  return `${year}年${month}月${day}日 ${hour}:${min}:${second}`;
}

export function getCopyrightJs(host) {
  const copyrightFileName = `${location.origin}/xxx`.replace(/https:\/\/.*?([^\.]+\.(com\.cn|org\.cn|net\.cn|[^\.]+))\/.+/, "$1")
  const copyrightScript = document.createElement("script");
  copyrightScript.setAttribute("type", "text/javascript");
  copyrightScript.setAttribute("src", `${host}/icp/bninfo.${copyrightFileName}.js`);
  document.body.appendChild(copyrightScript);
}


// WEBPACK FOOTER //
// ./web/js/generate-template/track2.js